const actionTypeIdentifier = '751D176A-D1AC-4276-B62E-0D2F8C9A9F76'; //action identifier should be unique

export const getMobileItems = `GET_MOBILE_ITEMS-${actionTypeIdentifier}`;
export const getHomeItems = `GET_HOME_ITEMS-${actionTypeIdentifier}`;
export const setMobileSearchValue = `SET_MOBILE_SEARCH_VALUE-${actionTypeIdentifier}`;
export const setHomeSearchValue = `SET_HOME_SEARCH_VALUE-${actionTypeIdentifier}`;
export const clearMobileSubscriptionItems = `CLEAR_MOBILE_SUBSCRIPTION_ITEMS-${actionTypeIdentifier}`;
export const clearHomeSubscriptionItems = `CLEAR_HOME_SUBSCRIPTION_ITEMS-${actionTypeIdentifier}`;
export const clearMobileSearchValue = `CLEAR_MOBILE_SEARCH_VALUE-${actionTypeIdentifier}`;
export const clearHomeSearchValue = `CLEAR_HOME_SEARCH_VALUE-${actionTypeIdentifier}`;
export const setItemPrimaryMobile = `SET_ITEM_PRIMARY_MOBILE-${actionTypeIdentifier}`;
export const setItemPrimaryHome = `SET_ITEM_PRIMARY_HOME-${actionTypeIdentifier}`;
export const getOtherSubscribersUnderLineManager = `GET_SUBSCRIBERS_UNDER_LINEMANAGER-${actionTypeIdentifier}`;
export const setSelectedUser = `SET_SELECTED_USER-${actionTypeIdentifier}`;
export const clearSelectedUser = `CLEAR_SELECTED_USER-${actionTypeIdentifier}`;
export const setActiveCircuit = `SET_ACTIVE_CIRCUIT-${actionTypeIdentifier}`;
export const clearActiveCircuit = `CLEAR_ACTIVE_CIRCUIT-${actionTypeIdentifier}`;
export const setTabKey = `SET_TABKEY_HOME_SIDE_NAV-${actionTypeIdentifier}`;
export const setMobileIsFetching = `SET_MOBILE_IS_FETCHING-${actionTypeIdentifier}`;
export const setHomeIsFetching = `SET_HOME_IS_FETCHING-${actionTypeIdentifier}`;
export const setIsPersonal = `SET_HOME_IS_PERSONAL_SIDE_TAB-${actionTypeIdentifier}`;
export const setSubscription = `SET_SUBSCRIPTION-${actionTypeIdentifier}`;
export const setCurrentToggleTab = `SET_CURRENT_TOGGLETAB-${actionTypeIdentifier}`;
export const setNoSubscriptionFound = `SET_NOSUBSCRIPTION_FOUND-${actionTypeIdentifier}`;
export const setSubscribers = `SET_SUBSCRIBERS-${actionTypeIdentifier}`;